import {
  useStatusAssinaturaProtocoloQuery
} from '@/hooks/useAssinaturas'
import { AssinarDocumentoButton } from './AssinarDocumentoButton'
import { AssinaturaStatusBadge } from './AssinaturaStatusBadge'

interface DocumentoAssinaturaCellProps {
  prontuarioId: number
  protocoloId: number
  tipoProtocolo: string
}

export function DocumentoAssinaturaCell({
  prontuarioId,
  protocoloId,
  tipoProtocolo
}: DocumentoAssinaturaCellProps) {
  const { data: statusData, isLoading } = useStatusAssinaturaProtocoloQuery(
    prontuarioId,
    protocoloId,
    tipoProtocolo
  )

  if (isLoading || !statusData) {
    return null
  }

  if (statusData.status === 'ASSINADO') {
    return (
      <AssinaturaStatusBadge
        status="ASSINADO"
        dataAssinatura={statusData.dataAssinatura}
      />
    )
  }

  return (
    <AssinarDocumentoButton
      prontuarioId={prontuarioId}
      protocoloId={protocoloId}
      tipoProtocolo={tipoProtocolo}
      size="sm"
      variant="outline"
    />
  )
}
